import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { Route, Switch } from 'react-router-dom';
import { getRouteStackPath } from '@portal/config/routes';
import PanelContent from '~/components/PanelContent/PanelContent';
import { sendEvent } from '@portal/services/firebase';
import { PageClass } from '@portal/enum/analytics';
import ProfileManagerList from './ProfileManagerList/ProfileManagerList';
import CreateProfileManager from './CreateProfileManager/CreateProfileManager';
import EditProfileManagerList from './EditProfileManager/EditProfileManager';
import { translate } from '@portal/services/i18n';

const ProfileManagerNavigationStack = () => {
  const location = useLocation();

  useEffect(() => {
    sendEvent('page_view', {
      firebase_page: location.pathname,
      firebase_page_class: PageClass.MANAGER_USER,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <Switch>
      <Route exact path={getRouteStackPath('PROFILE_MANAGER', 'PROFILE_LIST')}>
        <PanelContent
          pageTitle={translate('PAGES.PROFILE_MANAGER.TITLE_OF_STACK.GROUPS')}
        >
          <ProfileManagerList />
        </PanelContent>
      </Route>

      <Route exact path={getRouteStackPath('PROFILE_MANAGER', 'NEW_PROFILE')}>
        <PanelContent
          pageTitle={translate('PAGES.PROFILE_MANAGER.TITLE_OF_STACK.CREATED')}
        >
          <CreateProfileManager />
        </PanelContent>
      </Route>

      <Route exact path={getRouteStackPath('PROFILE_MANAGER', 'EDIT_PROFILE')}>
        <PanelContent
          pageTitle={translate('PAGES.PROFILE_MANAGER.TITLE_OF_STACK.EDIT')}
        >
          <EditProfileManagerList />
        </PanelContent>
      </Route>
    </Switch>
  );
};

export default ProfileManagerNavigationStack;
